export const DELIVERY_STATUS = {
	Canceled: 'canceled',
	Pickedup: 'picked-up',
	Accepted: 'accepted',
	DroppedOff: 'dropped-off',
};
